import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useTranslations } from "next-intl";
import { Card, Heading, Text } from "@/components/ui";
import { fetchJoinSettings } from "@/services/api/allowlist";

/** §31: the school admin's dashboard counter of join requests waiting for an answer. */
export function JoinRequestsCounter({ tenantSlug }: { tenantSlug: string }) {
  const t = useTranslations("allowlist");
  const query = useQuery({
    queryKey: ["join-settings", tenantSlug],
    queryFn: fetchJoinSettings,
  });
  if (!query.data) return null;
  const count = query.data.pendingRequestCount;
  return (
    <Card data-testid="join-requests-counter">
      <Heading as="h2" level="card">
        {t("counterTitle")}
      </Heading>
      <Text className="mt-1" data-testid="join-requests-counter-count">
        {t("counterPending", { count })}
      </Text>
      <Link
        to={`/t/${tenantSlug}/admin/join-requests`}
        className="mt-2 inline-block text-sm text-[var(--accent-ink)] underline underline-offset-4"
      >
        {t("counterLink")}
      </Link>
    </Card>
  );
}
